export const SIKI_CASHOUT_MAX_AMOUNT = 2000;
export const SIKI_CASHOUT_MIN_AMOUNT_NON_PROD = 5;

export function sikiCashoutLimits({ isProd, minimumCashout }) {
  return {
    minAmount: isProd ? minimumCashout : SIKI_CASHOUT_MIN_AMOUNT_NON_PROD,
    maxAmount: SIKI_CASHOUT_MAX_AMOUNT,
  };
}
